if (typeof TGN === 'undefined') TGN = {};
if (typeof TGN.Ancestry === 'undefined') TGN.Ancestry = {};
if (typeof TGN.Ancestry.Search === 'undefined') TGN.Ancestry.Search = {};
if (typeof TGN.Ancestry.Search.RecordMap === 'undefined') TGN.Ancestry.Search.RecordMap = {};
(function() {
	var RecordMap = TGN.Ancestry.Search.RecordMap;
    var credentials = "pk.eyJ1IjoiYW5jZXN0cnltYXBib3giLCJhIjoiNllqcGhKYyJ9.p9QKjx4kc2E_55jLTmDw0Q";
    var mapInitialized = false;
	
	// Shows an Ancestry modal with a map inside the element with name 'elemId'. 
	// Map will be centered on 'place'
    RecordMap.showMap = function (elemId, place) {
        if (!mapInitialized) {
            var geoCodingUrl = "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
                place +
                ".json?access_token=" +
                credentials +
                "&types=country,district,place,locality,address,neighborhood,region&country=us&limit=1";
            $.get(geoCodingUrl,
                function(data) {
                    $("#" + elemId).modal({
                        width: "940px",
                        onOpen: function() {
                            if (!mapInitialized) {
                                initMap(data);
                                mapInitialized = true;
                            }
                        }
                    });
                });
        } else {
            $("#" + elemId).modal({ width: "940px" });
        }
    };

    function initMap(places) {
        mapboxgl.accessToken = credentials;
        if (places.features.length > 0) {
            var place = places.features[0];
            var map = new mapboxgl.Map({
                container: "map",
                style: "mapbox://styles/mapbox/streets-v9",
                center: place.center,
                zoom: 12
            });
            map.on("load", function () {
                map.loadImage(RecordMap.pinUrl,
                    function (error, image) {
                        map.addImage("pin", image);
                        map.addLayer({
                            id: "points",
                            type: "symbol",
                            source: {
                                type: "geojson",
                                data: buildGeoJson(place)
                            },
                            layout: {
                                "icon-image": "pin",
                                "text-field": "{title}",
                                "text-font": ["Open Sans Semibold", "Arial Unicode MS Bold"],
                                "text-offset": [0, 0.6],
                                "text-anchor": "top",
                                "text-size": 12,
                                "icon-allow-overlap": true,
                                "text-allow-overlap": true
                            }
                        });
                    });
            });
        }
    }

    function buildGeoJson(feature) {
        return {
            "type": "FeatureCollection",
            "features": [
                {
                    "type": "Feature",
                    "properties": {
                        "title": feature.place_name
                    },
                    "geometry": {
                        "type": "Point",
                        "coordinates": feature.center
                    }
                }
            ]
        };
    }
}());
